import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import logo from "@/assets/logo_salone_vincente.png";
import { YouTubePlayer } from "@/components/YouTubePlayer";
import { usePageViewTracking } from "@/hooks/usePageViewTracking";
import { TRACKED_STEPS } from "@/config/tracking";
const VideoStep2 = () => {
  usePageViewTracking(TRACKED_STEPS.videoStep2);
  const [showButton, setShowButton] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  console.log('[VideoStep2] URL params:', {
    groupId: searchParams.get("groupId"),
    Id: searchParams.get("Id"),
    fullQueryString: searchParams.toString()
  });

  const handleTimeRemaining = (seconds: number) => {
    if (seconds <= 10 && seconds > 0 && !showButton) {
      setShowButton(true);
    }
  };

  const handleNext = () => {
    const queryString = searchParams.toString();
    navigate(`/6${queryString ? `?${queryString}` : ""}`);
  };
  return <div className="h-screen gradient-subtle flex flex-col p-4">
      {/* Contenuto principale centrato */}
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-5xl w-full flex flex-col">
          {/* Header orizzontale con logo e titolo */}
          <div className="flex items-center gap-4 mb-3 animate-fade-in">
            <img src={logo} alt="Salone Vincente" className="w-16 h-16 object-contain animate-float flex-shrink-0" />
            <h1 className="flex-1 text-center text-xl md:text-2xl font-bold bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">RESPONSABILITÀ E DOVERI DI CLIENTI, CONSULENTI E BEAUTY </h1>
          </div>

          {/* Video Container */}
          <div className="relative card p-3 shadow-elegant animate-slide-up">
            <YouTubePlayer 
              videoId="cjeBQzGiFv4" 
              onTimeRemaining={handleTimeRemaining}
              showButtonAt={10}
            />

            {showButton && <div className="mt-4 text-center animate-fade-in">
                <Button onClick={handleNext} size="lg" className="shadow-glow">
                  Continua al prossimo step dell'onboarding
                  <ChevronRight className="ml-2 h-5 w-5" />
                </Button>
              </div>}
          </div>

          {/* Footer */}
          {!showButton && <div className="text-center mt-3 text-base md:text-lg font-semibold text-foreground animate-pulse">
              <p>Guarda il video per continuare</p>
            </div>}
        </div>
      </div>
    </div>;
};
export default VideoStep2;